<template>
  <CardList
    ref="listRef"
    :title="tabItem.label"
    :options="pageOptions"
    :keyItem="tabItem"
    :dataType="{
      upload_type: UPLOAD_TYPE.BRAND,
      resource_type: tabItem.resource_type,
      model_type: tabItem.model_type,
    }"
    :upload="uploadOptions"
    :editData="editData"
    :batchs="getBatchs(status)"
  >
    <template #item="{ record, check, updateData }: any">
      <Card
        :data="transData(record, tabItem)"
        :edit="record.is_user_upload && !!editData"
        :keyItem="tabItem"
        :title="tabItem.label"
        :source="SOURCE.BRAND"
        :check="check"
        :menus="menuList"
        :menuFilter="curMenuFilter"
        :onUpdateData="updateData"
      />
    </template>
    <template #frag="{ updateData, upload }: any">
      <SelectForTeam
        :keyItem="tabItem"
        :upload="upload"
        :updateData="updateData"
      />
    </template>
    <template #emptyContent>
      <EmptyContent />
    </template>
    <template #emptyExtra="{ updateData, upload, uploadOpen }: any">
      <EmptyExtra
        :uploadOpen="uploadOpen"
        :upload="upload"
        :updateData="updateData"
      />
    </template>
  </CardList>
</template>
<script lang="ts" setup>
import {
  menu as getMenu,
  getBatchs,
  transData,
  EmptyContent,
  EmptyExtra,
  SelectForTeam,
} from '../config'
import { getBrandList } from '~/api'
import { type PageOptions } from '~/hooks/usePage'
import { ACCEPT } from '~/hooks/useUpload'
import { CardList, Card } from '~/features/pageList'

const menu = getMenu()

const props = defineProps<{
  hasUpload: boolean
  editData?: {
    [key: string]: (data: any, value: any) => Promise<any>
  }
  menuFilter: (key: any, item: any) => boolean
  status: number
}>()

const tabItem: any = useDictItem('brand', RESOURCE_TYPE.END)
const menuList = [menu.share, menu.rename, menu.cancel]
const listRef = ref()
const pageOptions = computed<PageOptions>(() => ({
  scroll: true,
  api: (params: any) =>
    getBrandList({
      ...params,
      resource_type: tabItem.resource_type,
      model_type: tabItem.model_type,
    }),
}))
const uploadOptions = computed(() => {
  if (!props.hasUpload) {
    return undefined
  }
  return {
    loca: true,
    accept: ACCEPT.VIDEO,
    onSuccess: (file: File) => {
      if (tabItem) {
        trackEvent(TRACK_EVENT.YOUYAN_PLATFORM_UPLOAD, {
          target: tabItem?.target,
          source: SOURCE.BRAND,
          filesize: file.size,
          fileType: file.type,
        })
        trackEvent(TRACK_EVENT.SET_AS_BRAND, {
          target: tabItem?.target,
          source: SOURCE.BRAND,
          click: SETASBRAND.LOCAL,
        })
      }
    },
  }
})
const curMenuFilter = (key: string, record: any) => {
  return props.menuFilter(key, record) && record.is_user_upload
}
const onTabChange = () => {
  listRef.value?.exitBatch()
  listRef.value?.toScrollTop()
}

const reload = () => {
  listRef.value?.reload()
}

defineExpose({ onTabChange, reload })
</script>

<style lang="scss" scoped></style>
